// extracted by mini-css-extract-plugin
export default {"dashboard-page":"AdminLayout_dashboard-page__LEPS6","main-part":"AdminLayout_main-part__gfEFd","pages-wrapper":"AdminLayout_pages-wrapper__GQCFb","bg":"AdminLayout_bg__WJeBa"};